/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_11_AInputs */

const en_tut_tr_11_a = /** @type {(inputs: Tut_Tr_11_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the **Pengingat rapat internal** group in **Settings → Notifikasi** — while it is muted the reminder's one chance is still used up and is not re-sent after you unmute. Make sure you are actually invited to that meeting, too; a division invitation only counts while the division is still active.`)
};

const id_tut_tr_11_a = /** @type {(inputs: Tut_Tr_11_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa kelompok **Pengingat rapat internal** di **Settings → Notifikasi** — kalau dibisukan, kesempatan pengingatnya tetap terpakai dan tidak dikirim ulang setelah dinyalakan. Pastikan juga Anda memang diundang ke rapat itu; undangan lewat divisi hanya berlaku selama divisinya masih aktif.`)
};

/**
* | output |
* | --- |
* | "Check the **Pengingat rapat internal** group in **Settings → Notifikasi** — while it is muted the reminder's one chance is still used up and is not re-sent a..." |
*
* @param {Tut_Tr_11_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_11_a = /** @type {((inputs?: Tut_Tr_11_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_11_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_11_a(inputs)
	return en_tut_tr_11_a(inputs)
});